export const getPriceRange = (isRoomsAggregator, rooms) => {
  let lowPrice = Number.MAX_VALUE;
  let highPrice = Number.MIN_VALUE;

  if (isRoomsAggregator) {
    rooms.forEach(elem => {
      lowPrice = Math.min(lowPrice, elem.price);
      highPrice = Math.max(highPrice, elem.price);
    });
  }

  return { lowPrice, highPrice };
};

export default {
  getPriceRange
};
